/** Filenames with spaces must be URL-encoded for `/images/...` paths. */
function imageFile(name: string): string {
  return `/images/${encodeURIComponent(name)}`;
}

/** Two documented before/after pairs */
export const BEFORE_AFTER = {
  project0: {
    before: '/images/00before.jpg',
    after: '/images/00after.jpg',
  },
  project1: {
    before: '/images/01before.jpg',
    after: '/images/01after.jpg',
  },
} as const;

/** Interior painting in progress (hero / portfolio) */
export const INTERIOR_PAINTING_SHOTS = {
  kitchenRenovation: '/images/PaintersWorkingOnKitchenRenovation.png',
  roomInProgress: '/images/Image-Apr-4-2026-01.png',
} as const;

/** Progress / finished shots (single photos) */
export const WORK_SHOTS = [
  imageFile('2026-04-03 22.30.12.jpg'),
  imageFile('2026-04-03 22.31.31.jpg'),
  imageFile('2026-04-03 22.31.40.jpg'),
  imageFile('PaintersWorkingOnKitchenRenovation.png'),
] as const;
